import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useBackgroundUrl } from '@/components/workshop/useWorkshopImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    isSelected: { type: Boolean, default: false },
    img: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "75e923cc": (_unref(stickerItem).mobile),
  "5f8fc844": (_unref(stickerItem).tablet),
  "24fa676b": (_unref(stickerItem).pc),
  "42bca06e": (_unref(stickerItemEffect).mobile),
  "2c6344e6": (_unref(stickerItemEffect).tablet),
  "539ad89a": (_unref(stickerItemEffect).pc)
}))



const { stickerItem, stickerItemEffect } = useBackgroundUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sticker', { 'sticker--selected': __props.isSelected }])
  }, [
    _createElementVNode("div", {
      class: "sticker__img",
      style: _normalizeStyle({ backgroundImage: `url(${__props.img})` })
    }, null, 4)
  ], 2))
}
}

})